import React, { useEffect } from 'react';
import ColorItem from './ColorItem';

export interface IColor {
  color: string;
  name: string;
  isDefault: boolean;
}

interface IProps {
  items: IColor[],
  selectedItems: string[],
  setSelectedItems: (data: string[]) => void;
  maxSelection?: number;
  defaultColorId?: string;
}

const ColorList = ({
  items, selectedItems, setSelectedItems, maxSelection, defaultColorId,
}:IProps) => {
  const getInitialSelection = () => {
    if (defaultColorId) {
      const initialColor = items.filter(clr => clr.color === defaultColorId)[0];
      return [initialColor.color];
    }
    const initialColor = items.filter(clr => clr.isDefault)[0];
    return [initialColor.color];
  };

  const getItemIdxByName = (itemName:string) => selectedItems.findIndex(name => name === itemName);

  const handleItemSelection = (name: string) => {
    if (maxSelection && maxSelection > 1) {
      const itemIdx = getItemIdxByName(name);
      if (itemIdx === -1) {
        if (selectedItems.length === maxSelection) {
          return;
        }
        const newState = [...selectedItems, name];
        setSelectedItems(newState);
      } else {
        const updatedList = [...selectedItems];
        updatedList.splice(itemIdx, 1);
        setSelectedItems(updatedList);
      }
    } else {
      const newState = [name];
      setSelectedItems(newState);
    }
  };

  useEffect(() => {
    setSelectedItems(getInitialSelection());
  }, []);
  return (
    <div className='w-[547px] max-h-[190px] h-fit flex flex-wrap gap-[14px] overflow-scroll'>
      {items.map(item => (
        <ColorItem key={item.color} handleItemSelection={() => handleItemSelection(item.color)} item={item} selectedItems={selectedItems} />
      ))}
    </div>
  );
};

export default ColorList;
